"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktDashboardCourbeTauxChart", function (mktCourbesTauxChartConfigFactory, mktCourbesTauxService) {
  return {
    restrict: "E",
    replace: false,
    scope: {
      currency: "="
    },
    template: '<tl-chart class="no-border" chart-config="chartConfigCourbeTaux"></tl-chart>',
    link: function link($scope, $el, $attrs, ctrl) {
      $scope.$watch("currency", function (currency) {
        mktCourbesTauxService.getCourbeTauxChartSeries(currency).then(function (chartSeries) {
          $scope.chartConfigCourbeTaux.series = chartSeries;
        });
      });
      $scope.chartConfigCourbeTaux = {
        options: mktCourbesTauxChartConfigFactory({
          height: 300
        })
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mktDashboardCourbeTauxChart.js
// module id = 2840
// module chunks = 13